import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { IconButton } from '../../../../../../CommonComponents/OPL/IconButton/IconButton';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { AddEditActionStep } from '../AddEditActionStep/AddEditActionStep';
import { useResetActionStepMutation } from '../../api/useResetActionStepMutation';
import { useActionSteps } from '../../ActionSteps/useActionSteps';
import { toast } from '../../../../../../CommonComponents/OPL/Toast/Toast';
import { isAdviserArea as selectIsAdviserArea } from '../../../../../../CommonSelectors/CommonAreaSelector';
import { Tooltip } from '../../../../../../CommonComponents/OPL/Tooltip/Tooltip';
import { ACTION_STEPS_TOOLTIP_TEXT } from '../../Tasks.constants';

interface ActionStepsHeaderProps {
  debtType?: number;
}

export const ActionStepsHeader = ({ debtType }: ActionStepsHeaderProps) => {
  const [showAddForm, setShowAddForm] = useState(false);

  const { isFetching, data } = useActionSteps();

  const isAdvisor = useSelector(selectIsAdviserArea);

  const {
    mutateAsync: resetTaskMutation,
    isLoading: resetIsLoading,
  } = useResetActionStepMutation();

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb="16">
        <Box display="flex" alignItems="center">
          <Text fontSize="h6" fontWeight={500} as="h2">
            Action Steps
          </Text>

          {isAdvisor ? (
            <IconButton
              icon="far fa-sync"
              variant="subtleInactive"
              size="small"
              onClick={async () => {
                try {
                  await resetTaskMutation();
                } catch (err) {
                  if (err instanceof Error) {
                    toast.error(err.message);
                  }
                }
              }}
              disabled={resetIsLoading || isFetching}
              aria-label="Reset action steps"
              ml="4"
            />
          ) : (
            <Tooltip content={ACTION_STEPS_TOOLTIP_TEXT}>
              <Icon className="far fa-info-circle" color="neutral.500" fontSize="small" ml="4" />
            </Tooltip>
          )}
        </Box>

        {isAdvisor && (
          <Box display="flex">
            <Button
              disabled={showAddForm || isFetching}
              leftIcon="fal fa-plus-circle"
              variant="subtleActive"
              onClick={() => setShowAddForm(true)}
              aria-label="Add action step"
              aria-expanded={showAddForm}
            >
              Action Step
            </Button>
          </Box>
        )}
      </Box>

      {showAddForm && (
        <AddEditActionStep
          setFormVisibility={setShowAddForm}
          debtType={debtType}
          pulseCheckCategory={data?.goal.PulseCheckCategory}
        />
      )}
    </Box>
  );
};
